import { Button, ButtonGroup, Stack, Tag, TagLabel } from '@chakra-ui/core'
import { usePageBasedPaging } from 'hooks/usePageSwitcher'
import React, { memo } from 'react'
import { Link } from 'react-router-dom'

const PageBasedPagination = ({ pageIndex, totalPages, totalItems }) => {
  const pages = usePageBasedPaging({
    pageIndex,
    totalPages,
  })

  return (
    <Stack
      isInline
      spacing={4}
      mt={8}
      alignItems="center"
      justifyContent="space-between"
    >
      <ButtonGroup spacing={3}>
        {pages.map(({ content, current, disabled, page, link }) => (
          <Button
            as={current || disabled ? undefined : Link}
            isDisabled={current || disabled}
            key={`page-${page}-${content}`}
            to={link}
          >
            {content}
          </Button>
        ))}
      </ButtonGroup>
      <Stack isInline spacing={2}>
        <Tag variant="outline" variantColor="blue">
          <TagLabel mr={1}>Total:</TagLabel> <span>{totalItems}</span>
        </Tag>
      </Stack>
    </Stack>
  )
}

export default memo(PageBasedPagination)
